import React from 'react';
import styles from './Content.module.scss';
import ShareTo from './ShareTo/ShareTo';
import Hero from '../Hero/Hero';
import { Image, Link, RichText } from '@sitecore-jss/sitecore-jss-react';
import arrow from '../../../../../../assets/icons/right-arrow.svg';

export default function Content({ fields }) {
  if (!fields) return null;
  const { content } = fields;

  return (
    <>
      <Hero hero={fields} />
      <div className={styles.wrapper} data-aos="fade-up">
        <div className={styles.container}>
          <RichText field={content}></RichText>
          {fields.link.value && fields.linkTitle.value && (
            <a
              className={styles.button}
              href={fields.link.value}
              target={fields.target.value ? fields.target.value : '_blank'}
              rel="noreferrer"
            >
              {fields.linkTitle.value} <Image src={arrow} alt={'Arrow'} width={16} height={16} />
            </a>
          )}
          <ShareTo fields={fields} />
        </div>
      </div>
    </>
  );
}
